// A project's automatic invoicing setup as its page shows and saves it. For a project without one the backend sends a
// new setup filled in with the invoice form's defaults, or from the project's latest invoice; its InvoiceAutomationId
// is then null. IsActive is read back only: saving the settings leaves the status alone, and Activate and Deactivate
// change it.
export default class InvoiceAutomationItem {
  InvoiceAutomationId: string;
  ProjectId: number;
  ProjectName: string;
  ClientId: number;
  IsNewSetup: boolean;
  IsActive: boolean;
  RunSchedule: string;
  JobMonthRule: string;
  FirstMonth: string;
  ContactId: number | string;
  CurrencyId: number | string;
  DaysToPay: number | string;
  LatePaymentInterestRate: number | string;
  Ponumber: string;
  ReferenceTemplate: string;
  CommentTemplate: string;
  DefaultReportName: string;
  ReportOrder: string;
  ReportGroup1: string;
  ReportGroup2: string;
  LastChangedOnUtc: string;
  LastChangedByUserId: number;
  LatestTpClientInvoiceId: number;
  SuggestedFields: string[];
  SuggestedValues: object;
  OtherProjectIds: number[];
  ClientProjects: { projectId: number; projectName: string }[];
  InvoicedWithProjectId: number;
  InvoicedWithProjectName: string;

  constructor(setup, project) {
    this.InvoiceAutomationId = setup?.invoiceAutomationId ?? null;
    this.ProjectId = setup?.projectId ?? project?.ProjectId;
    this.ProjectName = project?.ProjectName ?? '';
    this.ClientId = setup?.clientId;
    this.IsNewSetup = !setup?.invoiceAutomationId;
    this.IsActive = setup?.isActive === true;
    this.RunSchedule = setup?.runSchedule ?? '';
    this.JobMonthRule = setup?.jobMonthRule ?? '';
    this.FirstMonth = setup?.firstMonth ?? '';
    this.ContactId = setup?.contactId ?? '';
    this.CurrencyId = setup?.currencyId ?? '';
    this.DaysToPay = setup?.daysToPay ?? '';
    this.LatePaymentInterestRate = setup?.latePaymentInterestRate ?? '';
    this.Ponumber = setup?.ponumber ?? '';
    this.ReferenceTemplate = setup?.referenceTemplate ?? '';
    this.CommentTemplate = setup?.commentTemplate ?? '';
    this.DefaultReportName = setup?.defaultReportName ?? '';
    this.ReportOrder = setup?.reportOrder ?? '';
    this.ReportGroup1 = setup?.reportGroup1 ?? '';
    this.ReportGroup2 = setup?.reportGroup2 ?? '';
    // Read back only: who changed the setup last, and the project's latest invoice, a new setup's starting point.
    this.LastChangedOnUtc = setup?.lastChangedOnUtc ?? null;
    this.LastChangedByUserId = setup?.lastChangedByUserId ?? null;
    this.LatestTpClientInvoiceId = setup?.latestTpClientInvoiceId ?? null;
    // Read back only: the fields a new setup took from that invoice (the AI suggestion), and the values they took, so
    // that the edit wizard marks a field while it still holds its suggested value.
    this.SuggestedFields = setup?.suggestedFields ?? [];
    this.SuggestedValues = Object.fromEntries(this.SuggestedFields.map((fieldName) => [fieldName, this[fieldName]]));
    // The other projects of the client whose ready jobs go on this invoice too.
    this.OtherProjectIds = setup?.otherProjectIds ?? [];
    // Read back only: the client's projects that can go on the invoice, and, for a project with no setup of its own
    // that is on another setup's invoice, that setup's project.
    this.ClientProjects = setup?.clientProjects ?? [];
    this.InvoicedWithProjectId = setup?.invoicedWithProjectId ?? null;
    this.InvoicedWithProjectName = setup?.invoicedWithProjectName ?? null;
  }
}
